// UserRolesView.jsx
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import { checkIfUserAdmin, getUserRolesRows } from "./checkRowsUserData";

const UserRolesView = ({ entityData }) => {
  const [rows, setRows] = useState({});

  useEffect(() => {
    const userRolesRows = getUserRolesRows(entityData);
    const dictRoles = userRolesRows.reduce((acc, row) => {
      const source = row.source;
      if (!acc[source]) {
        acc[source] = [];
      }
      acc[source].push(row);
      return acc;
    }, {});
    setRows(dictRoles);
  }, [entityData]);

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      <Box display={"flex"} flexDirection={"column"} gap={1}>
        {checkIfUserAdmin(entityData) && (
          <Box display={"flex"} gap={1}>
            <Typography variant="subtitle2">Admin In</Typography>
          </Box>
        )}
        {entityData?.admin_roles && (
          <Box display={"flex"} flexDirection={"row"} ml={3} gap={1}>
            {Object.entries(entityData.admin_roles || {}).map(([platform]) => (
              <IntegrationImage
                key={platform}
                name={platform}
                width={"16px"}
                newLogo={true}
              />
            ))}
          </Box>
        )}
      </Box>
      <Box display={"flex"} flexDirection={"column"} gap={1}>
        <Box display={"flex"} gap={1} alignItems={"center"}>
          <Typography variant="subtitle2">Roles</Typography>
        </Box>
        <Box display={"flex"} flexDirection={"column"} ml={3} gap={1}>
          {Object.keys(rows).map((key) => {
            const rowsSource = rows[key];
            return (
              <Box key={key}>
                {rowsSource.map((row, index) => {
                  return (
                    <TextIntegrationStyle
                      key={row.id}
                      title={
                        index === 0 ? (
                          <Box display={"flex"} gap={1}>
                            <IntegrationImage
                              name={row.source}
                              width={"16px"}
                              newLogo={true}
                            />
                          </Box>
                        ) : (
                          <Box width={"16px"}></Box>
                        )
                      }
                      value={row.role_name}
                    />
                  );
                })}
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default UserRolesView;
